/* 甘寧傳・第 3 章：皖城（建安十九年，214）
 * 皖城在北，城南是被雨水漫過的低地（淺水）；吳軍的營在南邊。城牆只有南、北兩門，南門外是吊橋大路。
 * 甘寧從南牆兩處「緣城」的地方攀上去，進城後打開南門，讓呂蒙的兵進來；朱光在城北的太守府。 */
export const CITY = { x: 3600, y: 1900, hw: 1000, hh: 620 };
const T = 34, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATE = [CITY.x, S], NGATE = [CITY.x, N], FU = [CITY.x, N + 260], CAMP = [3600, 4400];
export const CLIMB = [[3000, S], [4250, S]]; // 緣城的地方（牆外）
export const WALL_S = S;
const h = (y: number) => [[(Wx + CITY.x - G) / 2, y, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, y, (E - CITY.x - G) / 2 + T, T]];
export default {
  id: 'ganning_wan', name: '皖城', W: 7200, H: 5200, seed: 214,
  bases: [CAMP, [CITY.x, CITY.y]],
  walls: [...h(N), ...h(S), [Wx, CITY.y, T, CITY.hh + T], [E, CITY.y, T, CITY.hh + T]],
  roads: [{ pts: [CAMP, [3600, 3400], GATE, [CITY.x, CITY.y], NGATE, [CITY.x, 300]], w: 120 }],
  marsh: [[2850, 2880, 560, 170], [4350, 2880, 560, 170], [3600, 3250, 1300, 120]],
  rocks: [[1100, 1000, 380, 170], [6100, 1000, 380, 170], [1200, 3900, 360, 160], [6000, 3900, 360, 160]],
  woods: 0.4,
  sight: 0.75,
  clearings: [[CITY.x, CITY.y, 1450], [CAMP[0], CAMP[1], 520], [CITY.x, 3000, 900]],
  villages: [{ x: CITY.x - 520, y: CITY.y + 120, n: 5, r: 260 }, { x: CITY.x + 520, y: CITY.y + 120, n: 5, r: 260 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 6, r: 380, chief: true, col: '#b8433a', flag: '呂' }],
};
